import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Utility from './../../Utility';
import GlobalContext from '../../contexts/GlobalContext';
import PageMessage from '../../components/Page/PageMessage';
import { Transition, Breadcrumb, Segment, Icon } from 'semantic-ui-react'
import './Page.css';

/**
 * Componentes page
 * @param {object} props.paramDisplay
 * @param {object} props.location
 * @param {object} props.children
 */
const Page = (props) => {
  const [globalContext] = useContext(GlobalContext);
  const [isVisible, setIsVisible] = useState(false);
  const [animation, setAnimation] = useState("");

  useEffect(() => {
    window.scrollTo({top:0})
  }, [])

  useEffect(() =>{
    if(props.paramDisplay === undefined) {
      setIsVisible(true);
    } else if (props.paramDisplay === true) {
      setIsVisible(true);
    }

    setAnimation("fade");
  }, [props.paramDisplay])

  /**
   * Retourne le Breadcrumb
   * @return Object Jsx
   */
  const getBreadcrumb = () => {
    let pathName = props.location.pathname.split('/');
    pathName = pathName.splice(3);//On delete les 3 premieres elements
    pathName = pathName.filter(word => word !== '');//on delete les elements vide
    let nbElement = pathName.length -1,
      listBreadcrumb = [],
      returnJsx = null;

    if (nbElement > 0) {
      let url = Utility.getUrlBaseName();

      let btnBack;
      for (let i = 0; i <= nbElement; i++) {
        let headerPage = Utility.getHeaderPage(pathName[i], globalContext.translations);
        url += '/' + pathName[i];
        listBreadcrumb.push(
          <div key={i}>
            <Breadcrumb.Section key={i} active={(i === pathName.length - 1) ? true : false}>
              <Link to={url}>
                {(typeof headerPage !== undefined) ? headerPage.header : pathName[i]}
              </Link>
            </Breadcrumb.Section>
            {(i === pathName.length - 1) ? null : <Breadcrumb.Divider icon="right angle" />}
          </div>
        );

        if (i === nbElement - 1) {
          btnBack = (
            <Segment as={Link} to={url} maxWidth={424} className="mt-4" id="btnBackbreadcrumbPage" size="mini">
              {(nbElement > 0) ? <Icon name="arrow left"/> : null}
              {(typeof headerPage !== undefined) ? headerPage.header : pathName[i]}
            </Segment>
          )
        }
      }

      returnJsx = (
        <div>
          <Segment as={Breadcrumb} minWidth={425} className="mt-4" id="breadcrumbPage" size="large">
            {listBreadcrumb}
          </Segment>
          {btnBack}
        </div>
      );
    }

    return (
      returnJsx
    );
  }

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <Transition visible={isVisible} animation={animation} duration={1000} children={
      <div>
        {(globalContext.headerPage.breadcrumb) ? getBreadcrumb() : null}
          <PageMessage listMessage={[]} />
        {props.children}
      </div>
    }>
    </Transition>
  )
}

export default Page;